export default "__VITE_ASSET__B19xV30x__"